import { jsx as _jsx } from "react/jsx-runtime";
import { MsalAuthenticationTemplate } from '@azure/msal-react';
import { AuthPrompt } from '../../utilities';
import { AuthInteractionEnum, AuthInteractionStatusEnum } from '../types';
import { useAuth } from './useAuth';
import { useAuthLoginViaHints } from './useAuthLoginViaHints';
/**
 * Render protected contents under this component.
 * This component will automatically authenticate user if not already authenticated, then renders children components
 * When authentication hints are present in the URL, this component will trigger a login flow based on those hints
 */
export const AuthenticatedTemplate = ({ children, errorComponent }) => {
    const { inProgress, auth } = useAuth();
    auth.logInfo('rendering AuthenticatedTemplate');
    const willStartLoginFlowExplicitly = useAuthLoginViaHints();
    // dont have to do anything else yet. need to wait for MSALProvider component to finish doing its things
    if (inProgress !== AuthInteractionStatusEnum.None)
        return null;
    auth.logInfo(`AuthenticatedTemplate: willStartLoginFlowExplicitly: ${willStartLoginFlowExplicitly}`);
    if (willStartLoginFlowExplicitly) {
        auth.logInfo('AuthenticatedTemplate: login to be done via auth.login explicitly');
        return null;
    }
    const accounts = auth.getAllAccounts();
    if (!auth.getActiveAccount() && accounts.length > 0) {
        // MSAL is in corrupted state:
        // => try recovering using the latest account store in browser storage
        const latestStoredAccount = auth.getLatestAccountFromStorage();
        if (latestStoredAccount) {
            auth.setActiveAccount(latestStoredAccount); // this will also set auth.user
        }
        else {
            // => last resort: ask the user to pick an account
            auth.login({ prompt: AuthPrompt.SELECT_ACCOUNT });
            return null;
        }
    }
    // On subsequent page reload after already authenticated the user, we want to make sure we use that user tenantId
    // to construct the tenanted authority so that we dont accidently look user back into his home tenant when they
    // were previously on his guest tenant. by default if /common is used, MSAL will log user into their home tenant
    const loginOption = {
        authority: auth.getAuthority(auth.user?.tenantId)
    };
    auth.logInfo(`AuthenticatedTemplate: rendering MSALAuthenticationTemplate ${JSON.stringify(loginOption)}`);
    return (_jsx(MsalAuthenticationTemplate, { interactionType: AuthInteractionEnum.Redirect, authenticationRequest: loginOption, errorComponent: errorComponent, children: children }));
};
//# sourceMappingURL=AuthenticatedTemplate.js.map